/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ClearAllAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function ClearAllAction({
  children,
  viewPath = "/DesignSystem/TasksFilters/Board/Content/Content/Content/Header/ClearAllAction"
  
}) {
let filtersBoardsValueData = fromData.useDataFormat({ viewPath,
context: 'filters',
path: 'boards',
format: fromFormat.isEmptyList,
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<fromFlow.When is={!filtersBoardsValueData}>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 paddingRight={0}
 paddingLeft={0}
 type="ghost"
 size="small"
 data="filters.boards"
 format="/Data/format.js isEmptyList"
 onClick={onClick}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Clear all"
/>
)}
</TysiaButton>
</fromFlow.When>
{children}
</React.Fragment>)
}